export default "__VITE_ASSET__Deo_v5Vx__"